import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import style from './style.module.scss';

class GlobalError extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
    };
  }

  close() {
    this.setState({
      show: false,
    });
  }

  render() {
    const { messages } = this.props;

    const { show } = this.state;

    return !!show ? (
      <div className={style.globalErrorContainer}>
        {messages}
        <span className={style.closeIcon} onClick={() => this.close()}>
          <Icon name="close" />
        </span>
      </div>
    ) : null;
  }
}

GlobalError.propTypes = {
  messages: PropTypes.any,
};

export default GlobalError;
